import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EformInfoService {

  mapCurrentJsonForm = new Map<String,{jsonPath:String,object:Object}>();
  mapFieldCurrentJsonForm = new Map<String,String>();

  dataToMap(data){
    data?.content?.forEach(section => {
      if(section.id && section.jsonPath && section.contentType=='group' && !this.mapCurrentJsonForm.has(section.id)){
          this.mapCurrentJsonForm.set(section.id,{jsonPath:section.jsonPath.replace('.val',''),object:section});
      } else if (section.contentType == 'field'){
        this.mapFieldCurrentJsonForm.set(section.id.toLowerCase(),section.jsonPath);
      }
      this.dataToMap(section);
    })
  }

  cleanService(){
    this.mapCurrentJsonForm = new Map<String,{jsonPath:String,object:Object}>();
    this.mapFieldCurrentJsonForm = new Map<String,String>();
  }

  constructor() { }
}
